import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './ui/Sidebar';
import Header from './ui/Header';

const SalesExecutiveLayout: React.FC = () => {
  const location = useLocation();

  // Map routes to page titles
  const getPageTitle = (pathname: string) => {
    switch (pathname) {
      case '/sales/dashboard':
        return 'Dashboard';
      case '/sales/leads':
        return 'Leads';
      case '/sales/vendor-onboarding':
        return 'Vendor Onboarding';
      case '/sales/reports':
        return 'Sales Reports';
      case '/sales/tasks':
        return 'Tasks';
      case '/sales/settings':
        return 'Settings';
      case '/sales/help':
        return 'Help & Support';
      default:
        return 'Sales Executive';
    }
  };

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title={getPageTitle(location.pathname)} />
        <main className="flex-1 overflow-y-auto p-6 dark:text-gray-100">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default SalesExecutiveLayout; 